import { createContext, useCallback, useContext, useEffect, useId, useRef, useState } from 'react';
import { setAxiosToastHandler } from 'utils/axios';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Modals
  const [showSpinner, setShowSpinner] = useState(false);
  const [showTransactionDetail, setShowTransactionDetail] = useState(false);
  const [showSendNotification, setShowSendNotification] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState({
    show: false,
    message: '',
    onClick: () => {},
    variant: 'primary',
    valueButton: 'Iya, Lanjutkan',
  });
  const [showBlockConfirmation, setShowBlockConfirmation] = useState({
    show: false,
    message: '',
    onClick: () => {},
  });
  const [showAddCar, setShowAddCar] = useState(false);
  const [showAddTourSchedule, setShowAddTourSchedule] = useState(false);
  const [showAddNewCity, setShowAddNewCity] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [showRefundDetail, setShowRefundDetail] = useState(false);
  const [showNotificationForm, setShowNotificationForm] = useState(false);
  const [showNotificationTemplate, setShowNotificationTemplate] = useState(false);
  const [showNotificationDetail, setShowNotificationDetail] = useState('list');
  const [showCityDeleteConfirmation, setShowCityDeleteConfirmation] = useState(false);
  const [showDepositDetailModal, setShowDepositDetailModal] = useState({
    show: false,
    history: false,
  });
  const [showDepositConfirmation, setShowDepositConfirmation] = useState(false);
  const [showAddDeliveryLocation, setShowAddDeliveryLocation] = useState({
    show: false,
    method: 'add',
  });
  const [showContactUsDetail, setShowContactUsDetail] = useState(false);
  const [showAddAboutUsImage, setShowAddAboutUsImage] = useState(false);
  const [showAddBannerModal, setShowAddBannerModal] = useState(false);
  const [showAddBrandCar, setShowAddBrandCar] = useState(false);
  const [cancelPaymentMessageValue, setCancelPaymentMessageValue] = useState('');
  const [showCancelPaymentMessage, setShowCancelPaymentMessage] = useState(false);
  const [showAddRolesModal, setShowAddRolesModal] = useState(false);
  const [showAddRolesAssignModal, setShowAddRolesAssignModal] = useState(false);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [showAddViolationsModal, setShowAddViolationsModal] = useState(false);
  const [showAssignDriver, setShowAssignDriver] = useState('');
  const [showZonePrice, setShowZonePrice] = useState(false);
  const [showRejectOrderModal, setShowRejectOrderModal] = useState(false);
  const [showAddAirportLocationType, setShowAddAirportLocationType] = useState(false);
  const [showAddAirportLocation, setShowAddAirportLocation] = useState(false);
  const [showAddNewLanguage, setShowAddNewLanguage] = useState(false);
  const [showAdditionalImageModal, setShowAdditionalImageModal] = useState(false);
  const [showReviewIdentityModal, setShowReviewIdentityModal] = useState({ type: '', show: false });
  const [showPreviewImageIdentity, setShowPreviewImageIdentity] = useState({ image: '', show: false });
  const [showAddRentalDurationModal, setShowAddRentalDurationModal] = useState(false);
  const [showBroadcastTask, setShowBroadcastTask] = useState(false);
  const [showCancelDriverTask, setShowCancelDriverTask] = useState(false);
  const [showWithdrawFeeModal, setShowWithdrawFeeModal] = useState(false);
  const [showRejectWithdrawFee, setShowRejectWithdrawFee] = useState(false);
  const [showRefundProcessModal, setShowRefundProcessModal] = useState(false);
  const [showRefundTransferModal, setShowRefundTransferModal] = useState(false);
  const [showRejectRefundModal, setShowRejectRefundModal] = useState(false);
  const [showDownloadInvoiceAndPdfDataModal, setShowDownloadInvoiceAndPdfDataModal] = useState({
    show: false,
    onDownloadInvoice: () => {},
    onDownloadPdfData: () => {},
  });
  const [showRejectDriverModal, setShowRejectDriverModal] = useState(false);
  const [showDeleteDriverReasonModal, setShowDeleteDriverReasonModal] = useState(false);
  const [showCancelTaskCharter, setShowCancelTaskCharter] = useState(false);
  const [showBroadcastTaskCharter, setShowBroadcastTaskCharter] = useState(false);
  const [showConfirmBroadcastTaskCharter, setShowConfirmBroadcastTaskCharter] = useState({
    show: false,
    fee: 0,
    task_type: '',
    driver: '',
    currency: 'SGD',
  });
  const [showVehiclePriceConfirmation, setShowVehiclePriceConfirmation] = useState({
    show: false,
    onConfirm: () => {},
    vehicleName: '',
  });
  const [showCancelExtendCharter, setShowCancelExtendCharter] = useState({
    show: false,
    transaction_key: '',
  });

  const toastId = useId();

  const toastListRef = useRef(toastList);

  const showToast = useCallback(
    (payload) => {
      if (toastListRef.current[toastListRef.current.length - 1]?.payload.message === payload.message) return;
      setToastList((toasts) => [
        ...toasts,
        {
          id: toastId + Math.random().toPrecision(6).toString(),
          payload,
        },
      ]);
    },
    [toastId],
  );

  useEffect(() => {
    toastListRef.current = toastList;
  }, [toastList]);

  useEffect(() => {
    setAxiosToastHandler(showToast);
  }, [showToast]);

  return (
    <AppContext.Provider
      value={{
        showSpinner,
        setShowSpinner,
        showTransactionDetail,
        setShowTransactionDetail,
        showSendNotification,
        setShowSendNotification,
        showBlockConfirmation,
        setShowBlockConfirmation,
        showAddCar,
        setShowAddCar,
        showConfirmation,
        setShowConfirmation,
        showAddTourSchedule,
        setShowAddTourSchedule,
        toastList,
        setToastList,
        showToast,
        showAddNewCity,
        setShowAddNewCity,
        showRefundDetail,
        setShowRefundDetail,
        showNotificationForm,
        setShowNotificationForm,
        showNotificationTemplate,
        setShowNotificationTemplate,
        showNotificationDetail,
        setShowNotificationDetail,
        showCityDeleteConfirmation,
        setShowCityDeleteConfirmation,
        showDepositDetailModal,
        setShowDepositDetailModal,
        showDepositConfirmation,
        setShowDepositConfirmation,
        showAddDeliveryLocation,
        setShowAddDeliveryLocation,
        showContactUsDetail,
        setShowContactUsDetail,
        showAddAboutUsImage,
        setShowAddAboutUsImage,
        showAddBannerModal,
        setShowAddBannerModal,
        showAddBrandCar,
        setShowAddBrandCar,
        cancelPaymentMessageValue,
        setCancelPaymentMessageValue,
        showCancelPaymentMessage,
        setShowCancelPaymentMessage,
        showAddRolesModal,
        setShowAddRolesModal,
        showAddRolesAssignModal,
        setShowAddRolesAssignModal,
        showAddCategory,
        setShowAddCategory,
        showAddViolationsModal,
        setShowAddViolationsModal,
        showAssignDriver,
        setShowAssignDriver,
        showZonePrice,
        setShowZonePrice,
        showRejectOrderModal,
        setShowRejectOrderModal,
        showAddNewLanguage,
        setShowAddNewLanguage,
        showAddAirportLocationType,
        setShowAddAirportLocationType,
        showAddAirportLocation,
        setShowAddAirportLocation,
        showAdditionalImageModal,
        setShowAdditionalImageModal,
        showReviewIdentityModal,
        setShowReviewIdentityModal,
        showPreviewImageIdentity,
        setShowPreviewImageIdentity,
        showAddRentalDurationModal,
        setShowAddRentalDurationModal,
        showBroadcastTask,
        setShowBroadcastTask,
        showCancelDriverTask,
        setShowCancelDriverTask,
        showWithdrawFeeModal,
        setShowWithdrawFeeModal,
        showRejectWithdrawFee,
        setShowRejectWithdrawFee,
        showRefundProcessModal,
        setShowRefundProcessModal,
        showRefundTransferModal,
        setShowRefundTransferModal,
        showRejectRefundModal,
        setShowRejectRefundModal,
        showDownloadInvoiceAndPdfDataModal,
        setShowDownloadInvoiceAndPdfDataModal,
        showRejectDriverModal,
        setShowRejectDriverModal,
        showDeleteDriverReasonModal,
        setShowDeleteDriverReasonModal,
        showCancelTaskCharter,
        setShowCancelTaskCharter,
        showBroadcastTaskCharter,
        setShowBroadcastTaskCharter,
        showConfirmBroadcastTaskCharter,
        setShowConfirmBroadcastTaskCharter,
        showVehiclePriceConfirmation,
        setShowVehiclePriceConfirmation,
        showCancelExtendCharter,
        setShowCancelExtendCharter,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppProvider');
  }
  return context;
};
